import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { VentasComponent } from '../ventas/ventas.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { Articulo } from 'src/app/Models/articulo/articulo';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { ModalComponent } from '../../objects/modal/modal/modal.component';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';
@Component({
  selector: 'app-kardex',
  templateUrl: './kardex.component.html',
  styleUrls: ['./kardex.component.css']
})
export class KardexComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(VentasComponent, null) impventas: VentasComponent;

  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public tipoinforme = 0;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 10000;
  public cliente: Cliente = new Cliente;
  public listakardex: any[] = [];
  public totalentradas: number = 0;
  public totalsalidas: number = 0;
  public totaltarjetas: number = 0;
  public today = new Date();
  public empresa: any;
  public pagventas: any = 0;
  public articulos: Articulo[] = [];
  public alertType: AlertType = new AlertType();
  public articulo: Articulo = new Articulo();
  constructor(private data: DataService, private route: Router, private reportViewer:ReportViewerService) { }


  ngOnInit() {

  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.setInitialDates();
    this.showTab(1);
    this.getArticulos();
    this.getEmpresa()
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.info.hide();
    }, 10);
  }

  getEmpresa() {
    this.data.GetSimple(this.data.api.empresa).subscribe(r => {
      console.log("Empresa:", r);
      this.empresa = r[0];
    }), (error) => {
      console.log(error);

    };
  }

  async Kardex() {

    await this.GetData();
    // Llama a GetTotalCompras solo después de que GetData se haya completado
    await this.GetKardex();
    await this.getArticulo();
  }

  async getArticulo() {
    this.data.GetFromId(this.data.api.articulos, this.rangofechas.id).subscribe(r => {
      console.log("Articulo:", r);
      this.articulo = r;
    }), (error) => {
      console.log(error);

    };
  }


  async GetKardex() {
    this.listakardex.forEach(kardex => {
      if (kardex.tipomovimiento === 'ENTRADA') {
        this.totalentradas += +kardex.cantidad
        // console.log(this.totalentradas);

      } else if (kardex.tipomovimiento === 'SALIDA') {
        this.totalsalidas += +kardex.cantidad
        // console.log(this.totalsalidas);
      }
    });
  }

  showTab(i) {
    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }

  async GetData() {
    console.log(this.rangofechas);
    let filtro = new Filtro()
    filtro.fecini = this.rangofechas.fecini
    filtro.fecfin = this.rangofechas.fecfin
    filtro.id = this.rangofechas.id
    filtro.idsucursal = this.data.getSucursalId()
    console.log("Enviado: ", filtro);
    await this.data.AsyncPost(this.data.api.kardex, filtro).then(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.listakardex = r.map((item: any) => ({
          ...item,
          cantidad: parseInt(item.cantidad),
          saldo: parseInt(item.saldo)
        }))

      }
    }).catch(e => { console.log(e) });
  }


  setInitialDates() {
    const today = new Date();
    this.rangofechas.fecfin = this.formatearFechas(today);

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.rangofechas.fecini = this.formatearFechas(firstDayOfMonth);
  }

  formatearFechas(fecha) {
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  setRango() {
    let fechainicio = this.formatearFechas(this.rangofechas.fecini);
    let fechafin = this.formatearFechas(this.rangofechas.fecfin);
    this.rangofechas.fecini = fechainicio;
    this.rangofechas.fecfin = fechafin;
  }

  async imprimirKardex() {

    this.totalentradas = 0
    this.totalsalidas = 0
    this.listakardex = []
    // this.route.navigate(['printer/kardex']);
    await this.Kardex()
    setTimeout(() => {
      const blob = this.printerKardex();
      if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Kardex Físico',
            `kardex_fisico_${fecha}.pdf`
          );
        }
    }, 1500);
  }

  printerKardex(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'KARDEX FÍSICO', x: 85, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Nombre: ${this.articulo.nombre}.`, 10, 28);
      doc.text(`Cod: ${this.articulo.codigo}. Unidad de medida: ${this.articulo.unidad.unidad}.`, 10, 33);
      doc.text(`Del periodo ${this.rangofechas.fecini} al periodo ${this.rangofechas.fecfin}`, 10, 38);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 150, 38);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla
    const tableColumn = ['Fecha', 'Doc', 'Serie', 'Numero', 'Referencia', 'Entrada', 'Salida', 'Saldo'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#kardex tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      margin: { horizontal: 10, vertical: 40 },
      theme: 'grid',
      columnStyles: {
        5: { halign: 'right' },
        6: { halign: 'right' },
        7: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 10,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 175, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(12);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Doc', data.settings.margin.left, data.cursor.y);
        doc.text('Serie', data.settings.margin.left, data.cursor.y);
        doc.text('Numero', data.settings.margin.left, data.cursor.y);
        doc.text('Referencia', data.settings.margin.left, data.cursor.y);
        doc.text('Entrada', data.settings.margin.left, data.cursor.y);
        doc.text('Salida', data.settings.margin.left, data.cursor.y);
        doc.text('Saldo', data.settings.margin.left, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  async getArticulos() {
    console.log("obteniendo artculos");
    await this.data.AsyncGetSimple(this.data.api.articulos).then(r => {
      this.articulos = r;
    })
  }

  close() {
    this.btnclose.nativeElement.click();
  }


}

